<nav class="navbar navbar-main navbar-expand-lg position-sticky mt-4 top-1 px-0 mx-4 shadow-none navbar-transparent border-radius-xl z-index-sticky" id="navbarBlur" data-scroll="true">
    <div class="container-fluid py-1 px-3">
        <div class="sidenav-toggler sidenav-toggler-inner d-xl-block d-none me-2 ">
            <a class="nav-link text-body p-0" (click)="toggleSidenav()">
                <div class="sidenav-toggler-inner">
                    <i class="sidenav-toggler-line"></i>
                    <i class="sidenav-toggler-line"></i>
                    <i class="sidenav-toggler-line"></i>
                </div>
            </a>
        </div>
        <div class="d-flex align-items-center gap-3">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
                    <li *ngFor="let item of breadcrumb_items" class="breadcrumb-item text-sm" [class.active]="item.active" [attr.aria-current]="item.active ? 'page' : null">
                        <a *ngIf="!item.active && item.route" class="opacity-5 text-dark" [routerLink]="item.route">
                            {{ item.title | translate }}
                        </a>

                        <span *ngIf="item.active || !item.route" class="text-dark">
                            {{ item.title | translate }}
                        </span>
                    </li>
                </ol>
            </nav>
            <h4 class="mb-2 mt-0 reload-timer" *ngIf="(countdown_display?.remaining_seconds ?? 0) > 0">
                <span class="time" [ngClass]="{'timer-danger': (countdown_display?.remaining_seconds ?? 0) < 10,'timer-warning': (countdown_display?.remaining_seconds ?? 0) < 30,'timer-ok': (countdown_display?.remaining_seconds ?? 0) >= 30}">
                    {{ countdown_display?.display }}  
                </span>                    
            </h4>
        </div>
        
        <div class="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
            <div class="ms-md-auto pe-md-3 d-flex align-items-center w-100 w-md-50 w-lg-40">
                <div class="input-group">
                    <!-- <span class="input-group-text text-body"><i class="fas fa-search" aria-hidden="true"></i></span> -->
                    <!-- <input type="text" id="search_bar" class="form-control" placeholder="¿Que deseas hacer hoy...?"> -->
                </div>
            </div>
            <ul class="navbar-nav justify-content-end">
                <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
                    <a class="nav-link text-body p-0" id="iconNavbarSidenav">
                        <div class="sidenav-toggler-inner">
                            <i class="sidenav-toggler-line"></i>
                            <i class="sidenav-toggler-line"></i>
                            <i class="sidenav-toggler-line"></i>
                        </div>
                    </a>
                </li>
                <li class="nav-item px-3 d-flex align-items-center">
                    <a class="nav-link p-0">
                        <i class="fa fa-user fixed-plugin-button-nav cursor-pointer"></i>
                        {{ 'COMMON.WELCOME' | translate }} {{ user_data?.names }}
                    </a>
                </li>
                <li class="nav-item px-3 d-flex align-items-center">
                    <a class="nav-link p-0" (click)="toggleSidenav()">
                        <i class="fa fa-cog fixed-plugin-button-nav cursor-pointer"></i>
                    </a>
                </li>
                <li class="nav-item dropdown pe-2 d-flex align-items-center">
                    <div class="dropdown me-2" [class.show]="is_dropdown_open">
                        <a href="javascript:;" class="text-body p-0 position-relative" id="dropdownMenuButton" 
                        (click)="toggleDropdown($event)" [attr.aria-expanded]="is_dropdown_open">    
                            
                            <span class="nav-link p-0 d-inline-block">
                                <i class="fa fa-bell cursor-pointer"></i>
                            </span>
                            
                            <span *ngIf="list_summary.total > 0" class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary" style="font-size: 0.6rem; padding: 0.3em 0.5em;">
                                {{ list_summary.total }}
                            </span>
                        </a>
                        
                        <ul class="dropdown-menu dropdown-menu-end px-2 py-3" [class.show]="is_dropdown_open" aria-labelledby="dropdownMenuButton" style="min-width: 280px;">
                            <li>
                                <div class="d-flex justify-content-between align-items-center px-3 pb-2 mb-2 border-bottom w-100">
                                    <h6 class="mb-0 text-sm font-weight-bold">{{ 'NOTIFICATION.NOTIFICATIONS' | translate }}</h6>
                                    <a [routerLink]="['/notification/list']" (click)="closeDropdown()" class="text-xs font-weight-bold text-primary text-decoration-none text-nowrap ms-3">
                                        {{ 'NOTIFICATION.VIEW_ALL' | translate }}
                                    </a>
                                </div>
                            </li>
                            <li class="mb-2" *ngFor="let item of list_data">
                                <a class="dropdown-item border-radius-md" style="cursor: pointer;" (click)="onNotificationClick(item)">
                                    <div class="d-flex py-1">
                                        <div class="d-flex flex-column justify-content-center">
                                            <h6 class="text-sm font-weight-normal mb-1">
                                                {{ item.title }}
                                            </h6>
                                            <p class="text-xs text-secondary mb-0">
                                                {{ item.body }}
                                            </p>
                                        </div>
                                    </div>
                                </a>
                            </li>
                            <li *ngIf="list_data.length == 0" class="text-center text-secondary d-flex flex-column align-items-center justify-content-center" style="min-height: 120px;">
                                <i class="fa fa-bell-slash text-light mb-2" style="font-size: 1.5rem;"></i>
                                <span class="text-sm">{{ 'NOTIFICATION.EMPTY' | translate }}</span>
                            </li>
                        </ul>
                    </div>
                    
                    <ul class="dropdown-menu dropdown-menu-end px-2 py-3 me-sm-n4" aria-labelledby="dropdownMenuButton">
                        <li class="mb-2">
                            <a class="dropdown-item border-radius-md" href="javascript:;">
                                <div class="d-flex py-1">
                                    <div class="my-auto">
                                        <img src="assets/img/team-2.jpg" class="avatar avatar-sm  me-3 " alt="user image">
                                    </div>
                                    <div class="d-flex flex-column justify-content-center">
                                        <h6 class="text-sm font-weight-normal mb-1">
                                            <span class="font-weight-bold">New message</span> from Laur
                                        </h6>
                                        <p class="text-xs text-secondary mb-0">
                                            <i class="fa fa-clock me-1"></i>
                                            13 minutes ago
                                        </p>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li class="mb-2">
                            <a class="dropdown-item border-radius-md" href="javascript:;">
                                <div class="d-flex py-1">
                                    <div class="my-auto">
                                        <img src="assets/img/small-logos/logo-spotify.svg" class="avatar avatar-sm bg-gradient-dark  me-3 " alt="logo spotify">
                                    </div>
                                    <div class="d-flex flex-column justify-content-center">
                                        <h6 class="text-sm font-weight-normal mb-1">
                                            <span class="font-weight-bold">New album</span> by Travis Scott
                                        </h6>
                                        <p class="text-xs text-secondary mb-0">
                                            <i class="fa fa-clock me-1"></i>
                                            1 day
                                        </p>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item border-radius-md" href="javascript:;">
                                <div class="d-flex py-1">
                                    <div class="avatar avatar-sm bg-gradient-secondary  me-3  my-auto">
                                        <svg width="12px" height="12px" viewBox="0 0 43 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <title>credit-card</title>
                                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                                <g transform="translate(-2169.000000, -745.000000)" fill="#FFFFFF" fill-rule="nonzero">
                                                    <g transform="translate(1716.000000, 291.000000)">
                                                        <g transform="translate(453.000000, 454.000000)">
                                                            <path class="color-background" d="M43,10.7482083 L43,3.58333333 C43,1.60354167 41.3964583,0 39.4166667,0 L3.58333333,0 C1.60354167,0 0,1.60354167 0,3.58333333 L0,10.7482083 L43,10.7482083 Z" opacity="0.593633743"></path>
                                                            <path class="color-background" d="M0,16.125 L0,32.25 C0,34.2297917 1.60354167,35.8333333 3.58333333,35.8333333 L39.4166667,35.8333333 C41.3964583,35.8333333 43,34.2297917 43,32.25 L43,16.125 L0,16.125 Z M19.7083333,26.875 L7.16666667,26.875 L7.16666667,23.2916667 L19.7083333,23.2916667 L19.7083333,26.875 Z M35.8333333,26.875 L28.6666667,26.875 L28.6666667,23.2916667 L35.8333333,23.2916667 L35.8333333,26.875 Z"></path>
                                                        </g>
                                                    </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>
                                    <div class="d-flex flex-column justify-content-center">
                                        <h6 class="text-sm font-weight-normal mb-1">
                                            Payment successfully completed
                                        </h6>
                                        <p class="text-xs text-secondary mb-0">
                                            <i class="fa fa-clock me-1"></i>
                                            2 days
                                        </p>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </li>
                <li class="nav-item d-flex align-items-center">
                    <a class="nav-link logout-link px-0 fw-bold" (click)="logout()">
                        <i class="fa fa-user-slash me-sm-1"></i>
                        <span class="d-sm-inline d-none">{{ 'BUTTONS.LOGOUT' | translate }}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</nav>